import Avatar from '@material-ui/core/Avatar';
import { makeStyles, Theme } from '@material-ui/core/styles';
import * as React from 'react';

interface IUserAvatarProps {
  name: string | undefined;
  className?: string;
  color?: 'primary' | 'secondary' | 'inherit';
}

const useStyles = makeStyles((theme: Theme) => ({
  inherit: {},
  primary: { backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText },
  secondary: { backgroundColor: theme.palette.secondary.main, color: theme.palette.secondary.contrastText }
}));

let UserAvatar: React.FunctionComponent<IUserAvatarProps> = ({ className = '', name = '', color = 'inherit' }) => {
  const classes = useStyles();
  // splits on a space, maps the resulting array returning the first character
  const initials = React.useMemo(
    () =>
      name
        ? name
            .split(' ')
            .map(str => str[0])
            .join('')
            .toUpperCase()
        : '?',
    [name]
  );

  return (
    <Avatar className={`${classes[color]} ${className}`} title={name}>
      {initials}
    </Avatar>
  );
};

UserAvatar = React.memo(UserAvatar);
export { UserAvatar };
